import React, { useEffect, useMemo, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import { YMaps, Map, Placemark, ZoomControl } from '@pbe/react-yandex-maps';
import HotelInfoBlock from './HotelInfoComponents/HotelInfoBlock';
import HotelMainInfoItem from './HotelInfoComponents/HotelMainInfoItem';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import HotelInfoReviews from './HotelInfoComponents/HotelInfoReviews';
import '../../../../node_modules/react-image-gallery/styles/scss/image-gallery.scss';
import '../../../../node_modules/react-tabs/style/react-tabs.css';
import GeograftourReviews from './HotelInfoComponents/GeograftourReviews';
import geograftourAPI from '../../api/geograftourAPI';

export default function HotelInfoView({
  isHotelPopupOpened,
  toggleHotelPopup,
  hotel,
  hotelId,
  hotelPopupTabNumber = 0,
}) {
  const [hotelInfo, setHotelInfo] = useState('');

  const imageArr = useMemo(() => {
    if (!hotel || !hotel.images) return [];
    return hotel.images.image.map((image) => ({
      original: image,
      thumbnail: image,
    }));
  }, [hotel]);

  useEffect(() => {
    if (hotelId) {
      geograftourAPI
        .getHotelInfo(hotel.countrycode, hotelId)
        .then((res) => {
          if (res) {
            setHotelInfo(res);
          }
        })
        .catch((err) => {
          console.log(err);
          setHotelInfo('');
        });
    }
  }, [hotelId]);

  return isHotelPopupOpened ? (
    <div
      onClick={toggleHotelPopup}
      className={`hotel-popup ${
        isHotelPopupOpened ? 'hotel-popup__opened' : ''
      }`}
    >
      <YMaps>
        <article className="hotel-popup__container">
          {!hotel ? (
            <div>Loading</div>
          ) : (
            <>
              <div className="hotel__header-container">
                <div className="hotel__name-stars-container">
                  <span className="hotel__stars">{hotel.stars}*</span>
                  <h2 className="hotel__name">{hotel.name}</h2>
                  {hotel.rating ? (
                    <div className="hotel__rating">{hotel.rating}</div>
                  ) : null}
                </div>
                <div className="hotel__region">{`${hotel.country}, ${hotel.region}`}</div>
              </div>
              <Tabs defaultIndex={hotelPopupTabNumber}>
                <TabList className={'hotel__info-tab-container'}>
                  <Tab className={'hotel__info-tab'}>Об отеле</Tab>
                  <Tab className={'hotel__info-tab'}>Карта</Tab>
                  {hotelInfo.our_comments?.length > 0 ? (
                    <Tab className={'hotel__info-tab'}>Наши отзывы</Tab>
                  ) : null}
                  {hotel.reviews && hotel.reviews.review.length > 0 ? (
                    <Tab
                      className={'hotel__info-tab'}
                    >{`Отзывы (${hotel.reviews.review.length})`}</Tab>
                  ) : null}
                </TabList>
                <TabPanel>
                  <section className="hotel__container hotel__container-info">
                    {hotel.images ? (
                      <div className="hotel__photos">
                        <ImageGallery
                          items={imageArr}
                          originalHeight={450}
                          originalWidth={800}
                          autoPlay={false}
                          showPlayButton={false}
                        />
                      </div>
                    ) : null}
                    <div className="hotel__main-info-block hotel__info-basic">
                      <ul className="hotel__info-list">
                        <HotelMainInfoItem
                          header="Основан:"
                          data={hotel.build}
                        />
                        <HotelMainInfoItem
                          header="Последняя реконструкция:"
                          data={hotel.repair}
                        />
                        <HotelMainInfoItem
                          header="Расположение:"
                          data={hotel.placement}
                        />
                        <HotelMainInfoItem
                          header="Телефон:"
                          data={hotel.phone}
                        />
                        <HotelMainInfoItem header="Сайт:" data={hotel.site} />
                      </ul>
                    </div>
                    <HotelInfoBlock header={'Пляж'} data={hotel.beach} />
                    <HotelInfoBlock
                      header={'Бесплатные услуги'}
                      data={hotel.servicefree}
                    />
                    <HotelInfoBlock
                      header={'Платные услуги'}
                      data={hotel.servicepay}
                    />
                    <HotelInfoBlock header={'Услуги'} data={hotel.services} />
                    <HotelInfoBlock header={'Для детей'} data={hotel.child} />
                    <HotelInfoBlock header={'Питание'} data={hotel.meallist} />
                    <HotelInfoBlock
                      header={'Концепция питания'}
                      data={hotel.mealtypes}
                    />
                    <HotelInfoBlock
                      header={'Типы номеров'}
                      data={hotel.roomtypes}
                    />
                    <HotelInfoBlock header={'В номере'} data={hotel.inroom} />
                  </section>
                </TabPanel>
                <TabPanel>
                  <section className="hotel__container hotel__container-map">
                    <Map
                      defaultState={{
                        center: [hotel.coord1, hotel.coord2],
                        zoom: 12,
                        controls: [],
                        type: 'yandex#hybrid',
                      }}
                      height={400}
                      width={'100%'}
                    >
                      <Placemark geometry={[hotel.coord1, hotel.coord2]} />
                      <ZoomControl options={{ float: 'right' }} />
                    </Map>
                  </section>
                </TabPanel>
                {hotelInfo.our_comments?.length > 0 ? (
                  <TabPanel>
                    <section className="hotel__container geo-reviews">
                      <h3 className="geo-reviews__title">
                        Мнение специалистов Географии
                      </h3>
                      <GeograftourReviews reviews={hotelInfo.our_comments} />
                    </section>
                  </TabPanel>
                ) : null}
                {hotel.reviews && hotel.reviews.review.length > 0 ? (
                  <TabPanel>
                    <section className="hotel__container hotel__container-reviews">
                      <HotelInfoReviews reviews={hotel.reviews.review} />
                    </section>
                  </TabPanel>
                ) : null}
              </Tabs>
            </>
          )}
          <AiOutlineCloseCircle
            className="hotel-popup__close-btn"
            onClick={toggleHotelPopup}
          />
        </article>
      </YMaps>
    </div>
  ) : null;
}
